import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.css";
import logoImage from "../../../layout/assets/logo-black.png";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { login } from "../../actions";
import { showAlert } from "../../../../common/actions";
import setHeaders from "../../../dashboard/utils/CommonHeaders";
import Cookies from "js-cookie";
import { Input, Button } from "../../../../common/ui";

const Signin = ({
  auth: { isLoading, isAuthenticated, isFailed, errorMessage, token },
  login,
  showAlert,
  setIsLoading,
}) => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    if (!isLoading) {
      if (!username) {
        showAlert({
          isAlertOpen: true,
          alertType: "danger",
          alertMessage: "Please Enter a Valid Email!",
        });
      } else if (!password) {
        showAlert({
          isAlertOpen: true,
          alertType: "danger",
          alertMessage: "Please Enter a Valid Password!",
        });
      } else {
        login(username, password);
        setIsLoading(!isLoading);
      }
    }
  };

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        Cookies.set("token_", token, { path: "" });
        setHeaders(token);
        showAlert({
          isAlertOpen: true,
          alertType: "success",
          alertMessage: "Successfully Logged In!",
        });
        navigate("/");
      } else if (isFailed) {
        showAlert({
          isAlertOpen: true,
          alertType: "danger",
          alertMessage: errorMessage || "Login Failed!",
        });
      }
    }
    setIsLoading(isLoading);
  }, [isLoading]);

  const handleKeyDown = (ev) => {
    if (ev.keyCode === 13) {
      handleLogin();
    }
  };

  return (
    <div className={styles.container} onKeyDown={handleKeyDown}>
      <div className={styles.card}>
        <img src={logoImage} className={styles.logo} alt="Logo" />
        <h1 className={styles.title}>Welcome Back!</h1>
        <a
          href="https://epinics.com/#pricing"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.signUpLink}
        >
          Don't have an account? <b>Try for free!</b>
        </a>

        <div className={styles.formGroup}>
          <Input
            id="emailOrPhone"
            name="emailOrPhone"
            label="Email or Phone"
            type="text"
            value={username}
            onInput={(e) => setUsername(e.target.value)}
            autoFocus
          />
        </div>

        <div className={styles.formGroup}>
          <Input
            id="password"
            name="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onInput={(e) => setPassword(e.target.value)}
            showPasswordToggle
            onTogglePassword={() => setShowPassword(!showPassword)}
          />
          <button type="button" className={styles.forgotLink}>
            Forgot your password?
          </button>
        </div>

        <div className={styles.submitButton}>
          <Button fullWidth large onClick={handleLogin}>
            Sign in
          </Button>
        </div>
      </div>
    </div>
  );
};

Signin.propTypes = {
  login: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
});

export default connect(mapStateToProps, {
  login,
  showAlert,
})(Signin);
